export default __webpack_public_path__ + "static/media/photo--sm--ish-3.ed3271bf.jpg";